// Shared Card shell for auth dialog steps (login method, email, OTP, etc.)

import * as React from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/utilities/cn';

export type AuthStepCardProps = React.ComponentProps<typeof Card>;

export const AuthStepCard: React.FC<AuthStepCardProps> = ({
  className,
  ...props
}) => <Card className={cn('w-full text-base', className)} {...props} />;
